import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State, RootState } from './';
import * as fromShell from '@opm/ng-core';

export namespace RootSelectors {
  export const getRootState = createFeatureSelector<State, RootState>('root');

  export const getShellState = createSelector(
    getRootState, state => {
      return state ? state.shell : undefined
    });

  export const getEntitiesState = createSelector(getRootState, state => state.entities);
  export const getProfilesEntitiyState = createSelector(getEntitiesState, state => state.profiles);

  export const getProfileId = createSelector(fromShell.RootSelectors.getRouterParams, state => state ? state['profileId'] : '');
  export const getAgencies = createSelector(getRootState, state => state.lookups.agencies);
  export const getAgencyObjects = createSelector(getRootState, state => state.lookups.agencyObjects);
  export const getUnions = createSelector(getRootState, state => state.lookups.unions);
  export const getUnionObjects = createSelector(getRootState, state => state.lookups.unionObjects);
  export const getOlmrNumbers = createSelector(getRootState, state => state.lookups.olmrNumbers);
  export const getCpdfCodeObjects = createSelector(getRootState, state => state.lookups.cpdfCodeObjects);
  export const getBusCodes = createSelector(getRootState, state => state.lookups.busCodes);
  export const getBusCodeObjects = createSelector(getRootState, state => state.lookups.busCodeObjects);
  export const getAffiliationObjects = createSelector(getRootState, state => state.lookups.affiliationObjects);
  export const getModalLoginForm = createSelector(getRootState, state => state.shell.loginModal);
}
